import moment from "moment";
import CheckNewOrders from "../symbols/checkNewOrdersPending";

const initialState = {
  data: false,
  loading: false,
  error: false,
  timeStamp: moment().utc().format(),
  previousTimeStamp: false,
};

export default function CheckNewOrdersPendingReducer(
  state = initialState,
  action: any
) {
  switch (action.type) {
    case CheckNewOrders.CHECK_NEW_ORDERS_PENDING:
      return { ...state, loading: true, error: false };
    case CheckNewOrders.CHECK_NEW_ORDERS_PENDING_SUCCESS:
      const newTimeStamp = moment().utc().format();
      return {
        ...state,
        data: action.payload.Result,
        loading: false,
        error: false,
        timeStamp: newTimeStamp,
        previousTimeStamp: action.payload.Result ? state.timeStamp : false,
      };
    case CheckNewOrders.CHECK_NEW_ORDERS_PENDING_FAILURE:
      return {
        ...state,
        data: false,
        loading: false,
        error: true,
      };
    case CheckNewOrders.CHECK_NEW_ORDERS_PENDING_REFRESH_TIME_STAMP:
      const newTime = moment().utc().format();
      return {
        ...state,
        timeStamp: newTime,
        previousTimeStamp: false,
      };
    case CheckNewOrders.CLEAR_CHECK_NEW_ORDERS_PENDING:
      return {
        ...state,
        data: false,
        loading: false,
        error: false,
      };

    default:
      return state;
  }
}
